"use strict";

exports.__esModule = true;
exports.default = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _excluded = ["icon", "loading", "label", "disabled", "outline", "color", "size", "shape", "displayAsLink", "displayAsBlock", "type", "closeButton", "className", "children", "iconPosition", "labelAria"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The Button component is used to trigger an action within the current page.
 * It's not supposed to be used as a link to another destination.
 */
var Button = exports.Button = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var icon = props.icon,
    loading = props.loading,
    label = props.label,
    disabled = props.disabled,
    outline = props.outline,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    size = props.size,
    shape = props.shape,
    displayAsLink = props.displayAsLink,
    displayAsBlock = props.displayAsBlock,
    type = props.type,
    closeButton = props.closeButton,
    className = props.className,
    children = props.children,
    iconPosition = props.iconPosition,
    labelAria = props.labelAria,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = (0, _clsx.default)('uk-button', !closeButton && "uk-bdcolor--" + color, !closeButton && (displayAsLink ? "asLink uk-color--" + color : outline ? "uk-outline--" + color : "uk-bghcolor--" + color), displayAsBlock && 'asBlock', (disabled || loading) && 'uk-disabled', size !== 'default' && size, shape !== 'default' && shape, iconPosition !== 'left' && 'reverse', icon && !label && !children && 'icon-only', closeButton && 'uk-button--close', className);
  if (closeButton) {
    return /*#__PURE__*/_react.default.createElement("button", _extends({
      type: "button",
      className: classes
    }, attributes), /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"));
  }
  if (loading) {
    return /*#__PURE__*/_react.default.createElement("button", _extends({
      type: "button",
      className: classes,
      disabled: true
    }, attributes), /*#__PURE__*/_react.default.createElement("div", {
      className: "loading"
    }, /*#__PURE__*/_react.default.createElement("div", null)));
  }
  var provideAriaLabelText = function provideAriaLabelText() {
    if (icon && !label) {
      return labelAria || icon;
    } else if (!label) {
      return labelAria;
    } else {
      return undefined;
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    _react.default.createElement("button", _extends({
      type: type,
      className: classes,
      disabled: disabled,
      "aria-label": provideAriaLabelText(),
      ref: ref
    }, attributes), icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: icon
    }), label ? /*#__PURE__*/_react.default.createElement("span", null, label) : children)
  );
});
Button.propTypes = {
  /**
   * Label of the Button
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Size of the Button
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large']),
  /**
   * Background-color of the Button (or border-color if outline)
   */
  color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'black', 'white', 'custom'])]),
  /**
   * Shape of the Button
   */
  shape: _propTypes.default.oneOf(['default', 'round']),
  /**
   * Invert styling colors of the Button
   */
  outline: _propTypes.default.bool,
  /**
   * Remove the styling to make the Button appear as a link
   */
  displayAsLink: _propTypes.default.bool,
  /**
   * Expands the Button to make it full-width of its container
   */
  displayAsBlock: _propTypes.default.bool,
  /**
   * Type of the Button
   */
  type: _propTypes.default.oneOf(['button', 'submit']),
  /**
   * Add an Icon in the Button
   */
  icon: _propTypes.default.string,
  /**
   * Alignment of the Icon within the Button
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Set the Button as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Replace the content of the Button by a loading animation
   */
  loading: _propTypes.default.bool,
  /**
   * Experimental
   */
  closeButton: _propTypes.default.bool,
  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string
};
Button.defaultProps = {
  label: '',
  labelAria: '',
  size: 'default',
  color: 'primary',
  shape: 'default',
  outline: false,
  disabled: false,
  displayAsLink: false,
  displayAsBlock: false,
  type: 'button',
  icon: null,
  iconPosition: 'left',
  loading: false,
  closeButton: false
};
var _default = exports.default = Button;